import { createDomain } from 'effector';
import { createGate } from 'effector-react';

const domain = createDomain('hotspot');

export const $GateHotspotBatchMode = createGate<boolean>({
  defaultState: false,
  domain,
});

export const $GateHotspotGroupMode = createGate<boolean>({
  defaultState: false,
  domain,
});

export const $gateHotspotLayerMode = createGate<boolean>({
  defaultState: false,
  domain,
});
